var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElPrixDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1697.81 115.89"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "ElPrixDesktop_svg__a",
  cx: 781.23,
  cy: 15.99,
  fx: 781.23,
  fy: 15.99,
  r: 382.72,
  gradientTransform: "matrix(1 0 0 .19 0 12.91)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#aee7b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff6ce",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ElPrixDesktop_svg__b",
  cx: 1018.93,
  cy: 15.99,
  fx: 1018.93,
  fy: 15.99,
  r: 382.72,
  gradientTransform: "matrix(1.71 0 0 .19 -753.78 12.91)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c2d8ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff6ce",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ElPrixDesktop_svg__c",
  cx: 311.4,
  cy: 15.99,
  fx: 311.4,
  fy: 15.99,
  r: 382.72,
  gradientTransform: "matrix(.6 0 0 .23 197.16 12.27)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffc3e9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff6ce",
  stopOpacity: 0
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M359.2 15.84c2.92 45.34 189.07 81.91 418.28 81.91s415.36-36.57 418.28-81.91H359.2Z",
  style: {
    fill: "url(#ElPrixDesktop_svg__a)",
    opacity: 0.6,
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.07 15.84c4.99 45.34 323.36 81.91 715.37 81.91s710.38-36.58 715.37-81.91H267.07Z",
  style: {
    fill: "url(#ElPrixDesktop_svg__b)",
    strokeWidth: 0,
    opacity: 0.5
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.27 15.84c1.74 55.38 112.62 100.05 249.14 100.05s247.4-44.67 249.14-100.05H131.27Z",
  style: {
    strokeWidth: 0,
    opacity: 0.5,
    fill: "url(#ElPrixDesktop_svg__c)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M.03 13.49c236.62 21.3 473.55-3.07 710.3-7.75 25.4-.41 50.8-.6 76.19-1.24 42.33.03 84.66.71 126.97 1.6 101.52 1.12 202.9 10.36 304.44 7.77 67.65-2.37 135.28-6.1 202.98-7.24 67.69-.87 136.69-2.78 203.72-.9-67.05 1.9-136 .64-203.67 3.01-67.7 1.45-135.28 5.48-202.94 8.15-67.73 2.37-135.48-1.52-203.13-3.88-67.64-2.43-135.32-3.54-203-3.91-25.38.17-50.76-.91-76.14-.53C491.18 10.17 242.47 37.63.03 13.49Z",
  style: {
    fill: "#f4abde",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 14.43c143.34.37 288.13-2.91 431.49-6.78 93.09-2.32 186.21.61 279.24 3.9 135.3 4.01 270.72 1.15 406.05-1.31 33.87-.38 67.76.02 101.6 1.28 33.83 1.29 67.56 3.61 101.42 3.02 67.68-.65 135.1-8.03 202.68-11.45 33.81-1.79 67.68-2.74 101.54-2.67.33 0 .6.27.6.6 0 .33-.27.6-.6.6-33.84.08-67.67 1.18-101.45 3.12-67.6 3.72-134.98 11.41-202.74 12.36-33.87.75-67.74-1.42-101.56-2.57-33.81-1.11-67.63-1.36-101.46-.83-135.11 2.86-271.03 7.28-406.19.92-84.55-3.23-169.1-6.6-253.72-5.39-151.27 2.2-307.42 7.78-456.9 5.2Z",
  style: {
    fill: "#bae8bb",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.55 10.56C262.88 25.23 513.07-1.63 763.48.45c118.81.16 244.39 6.98 363.38 10.01 48.46.81 96.82-1.94 145.22-4.24C1368.9.85 1465.91-.36 1562.84.78c.14 0 .25.11.25.25s-.11.25-.25.25c-48.46.37-96.93.65-145.38 1.73-80.78 1.63-161.37 7.88-242.13 10.01-65.68 1.51-151.92-4.5-218.05-6.49-56.36-2.3-113.2-2.79-169.58-2.77-257.82-4.81-519.35 25.07-775.15 6.8Z",
  style: {
    fill: "#b0d4ff",
    strokeWidth: 0
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.72 11.56c153.93 10.29 308.85 6.11 462.85-1.01 24.23-.88 48.93-1.56 73.13-2.05 209.64-5.91 424.23 6.41 633.81-2.28 48.72-1.89 97.4-5.21 146.17-6.05 48.78-.84 97.53 1.73 146.26 3.14 32.5 1.19 65.51.96 97.74 1.79-32.25.8-65.26-.17-97.77-.8-48.74-1.25-97.45-3.66-146.21-2.67-48.75.95-97.41 4.23-146.13 6.17-178.68 8.13-357.56-1.52-536.33 1.9-52.27.65-106.13 2.02-158.39 3.78-68.05 2.49-139.13 6.3-207.14 6.85-23.21.22-49.97.33-73.17.04-64.41-1.32-132.53-1.89-194.84-8.8Z",
  style: {
    fill: "#ffefa0",
    strokeWidth: 0
  }
})));
export default SvgElPrixDesktop;